/*
PROV: COHINT001.BF.D1LNLA3Z2A
REQ: SYS-ARCH-15, AUD-UX-13, UX-BASE-05
WHY: Shared package module.
*/

import type { LucideIcon } from "lucide-react";

export function Icon({ icon: IconComponent, size = 18, className }: { icon: LucideIcon; size?: number; className?: string }) {
  return <IconComponent width={size} height={size} className={className} aria-hidden="true" focusable="false" />;
}
